module.exports = __webpack_public_path__ + "img/occidental-room2.ecf16bd2.jpg";